import { createSupport } from './createSupport'
import { getAllSupports } from './getAllSupports'
import { listPersonTransactions } from './listPersonTransactions'

export const supportService = {
  getAllSupports,
  createSupport,
  listPersonTransactions,
}
